import React from "react";
import styled from "styled-components";

interface CouponPreviewBoxProps {
  selectPromotionData?: {
    PROM_ID?: number;
    PROM_NM?: string;
    PROM_DESC?: string;
    PROM_SVCID?: number;
    PROM_USER?: number;
    PROM_SDATE?: string;
    PROM_EDATE?: string;
    PROM_MXCNT?: number;
    PROM_DISCRT?: number;
    PROM_LMTPX?: number;
    INDIV_DEDLM?: number;
    PNTR_ALIAS?: string;

    LPPR_ID?: number;
    LPPR_NM?: string;
    LPPR_SDATE?: string;
    LPPR_EDATE?: string;
    LPPR_MXCNT?: number;
    LPSCH_TYP?: number;
    LPSCH_CNT?: number;
    LPPR_VAL?: number;
    LPPR_DL?: number;
    LPPR_ALIAS?: string | null;
  };
  isPoint?: boolean;
}

export default function CouponPreviewBox({
  selectPromotionData,
  isPoint,
}: CouponPreviewBoxProps) {
  console.log(selectPromotionData);

  return (
    <CouponPreviewBoxContainer>
      {selectPromotionData ? (
        <>
          <CouponColumn>
            {isPoint ? (
              <>
                <CouponColumnLabel>promotion_nm</CouponColumnLabel>
                <CouponColumnLabel>Promotion 기간</CouponColumnLabel>
                <CouponColumnLabel>발급 제한</CouponColumnLabel>
                <CouponColumnLabel>타입</CouponColumnLabel>
                <CouponColumnLabel>지급 횟수</CouponColumnLabel>
                <CouponColumnLabel>값</CouponColumnLabel>
                <CouponColumnLabel>지급 포인트 마감기간</CouponColumnLabel>
              </>
            ) : (
              <>
                <CouponColumnLabel>promotion_nm</CouponColumnLabel>
                <CouponColumnLabel>사용 가능 서비스</CouponColumnLabel>
                <CouponColumnLabel>사용 대상</CouponColumnLabel>
                <CouponColumnLabel>Promotion 기간</CouponColumnLabel>
                <CouponColumnLabel>발급 총량</CouponColumnLabel>
                <CouponColumnLabel>혜택율</CouponColumnLabel>
                <CouponColumnLabel>할인한도</CouponColumnLabel>
                <CouponColumnLabel>개별코드 마감기간</CouponColumnLabel>
              </>
            )}
          </CouponColumn>

          <CouponColumn>
            {isPoint ? (
              <>
                <CouponColumnValue>
                  {selectPromotionData?.LPPR_NM ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPPR_SDATE ?? ""} ~{" "}
                  {selectPromotionData?.LPPR_EDATE ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPPR_MXCNT?.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  ) ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPSCH_TYP ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPSCH_CNT ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPPR_VAL ?? ""}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.LPPR_DL ?? ""}
                </CouponColumnValue>
              </>
            ) : (
              <>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_NM}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_SVCID}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_USER === 0
                    ? "파티장"
                    : selectPromotionData?.PROM_USER === 1
                    ? "파티원"
                    : "모두 "}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_SDATE} ~{" "}
                  {selectPromotionData?.PROM_EDATE}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_MXCNT?.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_DISCRT
                    ? selectPromotionData?.PROM_DISCRT / 100
                    : null}
                  %
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.PROM_LMTPX?.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </CouponColumnValue>
                <CouponColumnValue>
                  {selectPromotionData?.INDIV_DEDLM}
                </CouponColumnValue>
              </>
            )}
          </CouponColumn>
        </>
      ) : null}
    </CouponPreviewBoxContainer>
  );
}

const CouponPreviewBoxContainer = styled.div`
  width: 100%;
  padding: 16px;
  border-radius: 3px;
  background-color: #f6f6f8;
  display: flex;
  align-items: center;
`;

const CouponColumn = styled.div`
  display: flex;
  flex-direction: column;

  &:first-child {
    width: 150px;
  }

  &:last-child {
    width: calc(100% - 150px);
  }
`;

const CouponColumnLabel = styled.label`
  font-size: 13px;
  font-weight: bold;
  line-height: 19.5px;
  text-align: left;
  color: #808080;
`;

const CouponColumnValue = styled(CouponColumnLabel)`
  font-weight: 500;
`;
